import { useEffect, useState } from "react";

const breakpoints = {
  mobile: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  laptop: 1440,
  "3xl": 1800,
};

export function useBreakpoint() {
  const [bp, setBp] = useState("default");

  useEffect(() => {
    function calcBp() {
      const width = window.innerWidth;
      if (width >= breakpoints["3xl"]) return setBp("3xl");
      if (width >= breakpoints.laptop) return setBp("laptop");
      if (width >= breakpoints.xl) return setBp("xl");
      if (width >= breakpoints.lg) return setBp("lg");
      if (width >= breakpoints.md) return setBp("md");
      if (width >= breakpoints.sm) return setBp("sm");
      if (width >= breakpoints.mobile) return setBp("mobile");
      return setBp("default");
    }
    calcBp();
    window.addEventListener("resize", calcBp);
    return () => window.removeEventListener("resize", calcBp);
  }, []);

  return bp;
}
